// extracted by mini-css-extract-plugin
module.exports = {"sb-show-main":"Footer_sb-show-main__2bLtU","sb-main-padded":"Footer_sb-main-padded__1d3Py","underline":"Footer_underline__1yWA6","footer":"Footer_footer__O-F5D"};